import Devices from './Devices';
import { Printer } from '../../models';

class Printers extends Devices {
    constructor() {
        super({
            model: Printer,
            entryPoint: 'printers',
            resource:   'printer',
            resources:  'printers'
        });
    }
}

const PrintersApi = new Printers();

export default PrintersApi;
